import { Pipe, PipeTransform } from '@angular/core';

import { MonitorKey } from '../models/view-models/monitor-models/monitor-key.type';
import { Monitor } from '../models/entities/monitor.type';

@Pipe({
  name: 'findAssignedMonitors',
  standalone: true
})
export class FindAssignedMonitorsPipe implements PipeTransform {

  transform(monitorKeys: MonitorKey[], allMonitors: Monitor[]): Monitor[] {

    if (!monitorKeys?.length || !allMonitors?.length) {
      return null;
    }

    return allMonitors.filter(monitor =>
      monitorKeys.some(monitorKey => monitorKey.MonitorHandler === monitor.MonitorHandler &&
        monitorKey.MachinePhysicalAddress === monitor.MachinePhysicalAddress));
  }

}
